import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { del, get, post, put } from "../../helpers/api_helper"
import { APIServerIP } from "../../../src/helpers/Sats_api_helper"

const initialVenueState = {
  VenueList: [],
  volunteers: [],
  TicketBookedDetails: [],
  scannedList: [], 
  VenueisSuccessfully: false,
  isUserEdit: false,
  scannedUser: null,
  scannedUserStatus: null,
  scannerStatusMessage: null
}

const VenueSlice = createSlice({
  name: "EventVenue",
  initialState: initialVenueState,
  reducers: {
    setScannedList: (state, action) => {
  state.scannedList = action.payload
},
    setVenueList: (state, action) => {
      state.VenueList = action.payload
    },
    setVenueSuccessfullyAdded: (state, action) => {
      state.VenueisSuccessfully = true
    },
    setUserEdit: (state, action) => {
      state.isUserEdit = true
    },
    setvolunteerList: (state, action) => {
      state.volunteers = action.payload
    },
    setTicketBookedList: (state, action) => {
      state.TicketBookedDetails = action.payload
      state.VenueisSuccessfully = true
    },
    resetVenue: (state, action) => {
      state.VenueisSuccessfully = false
      state.isUserEdit = false
    },
    // ticketScanned: (state, action) => {
    //   state.scannedUser = action.payload.data
    //   state.scannedUserStatus = action.payload.message_code
    //   state.scannerStatusMessage = action.payload.message
    // },
    ticketScanned: (state, action) => {
  const data = action.payload.data
  const status = action.payload.status   // ✅ FIXED

  state.scannedUser = data
  state.scannedUserStatus = status
  state.scannerStatusMessage = action.payload.message

  // only add if new scan
  if (status === "SUCCESS") {
    const exists = state.scannedList.find(
      item => item._id === data._id
    )

    if (!exists) {
      state.scannedList = [
        {
          ...data,
          createdAt: new Date().toISOString(),
        },
        ...state.scannedList,
      ]
    }
  }
},
    resetScannedData: (state, action) => {
      state.scannedUser = null
      state.scannedUserStatus = null
      state.scannerStatusMessage = null
    },
  },
})

export const createVenue = values => {
  return async dispatch => {
    try {
      dispatch(resetVenue())
      const responseData = await post(
        `${APIServerIP}manage-event-venue/create-event-venue`,
        values
      )
      // console.log("Venue user", responseData)
      if (responseData.response_code === 200) {
        dispatch(setVenueSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}
export const updateVenue = values => {
  return async dispatch => {
    try {
      dispatch(resetVenue())
      const responseData = await post(
        `${APIServerIP}manage-event-venue/update-event-venue`,
        values
      )
      // console.log("Venue user", responseData)
      if (responseData.response_code === 200) {
        dispatch(setVenueSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}

export const deleteVenue = id => {
  return async dispatch => {
    try {
      dispatch(resetVenue())
      const responseData = await post(
        `${APIServerIP}manage-event-venue/delete-event-venue`,
        id
      )

      if (responseData.response_code === 200) {
        console.log("Venue user", responseData)
        dispatch(setVenueSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}
export const activeInactiveVenue = data => {
  return async dispatch => {
    try {
      dispatch(resetVenue())
      const responseData = await post(
        `${APIServerIP}manage-event-venue/SetactiveInactive-manage-event-venue`,
        data
      )

      if (responseData.response_code === 200) {
        // console.log("active user", responseData)
        dispatch(setVenueSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}

export const editUser = data => {
  return async dispatch => {
    try {
      localStorage.setItem("editUser", JSON.stringify(data))
      dispatch(setUserEdit())
    } catch (err) {
      console.log("editUsererr", err)
    }
  }
}

export const fetchVenue = id => {
  // console.log(id)
  return async dispatch => {
    dispatch(resetVenue())
    try {
      let responseData = await post(
        `${APIServerIP}manage-event-venue/fetch-event-venues`,
        { master_event_id: id }
      )
      // console.log("active get users", responseData)
      if (responseData.response_code === 200) {
        dispatch(setVenueList(responseData.data))
      }
    } catch (error) {
      console.log("try error fetch", error)
    }
  }
}
export const TicketBookedHistory = id => {
  // console.log(id)
  return async dispatch => {
    dispatch(resetVenue())
    try {
      let responseData = await post(
        `${APIServerIP}manage-booking-user/fetch-venue-ticket-booking-user`,
        { master_venue_id: id }
      )
      console.log("TicketBookedHistory", responseData)
      if (responseData.response_code === 200) {
        dispatch(setTicketBookedList(responseData.data))
      }
    } catch (error) {
      console.log("try error fetch", error)
    }
  }
}

export const volunteerList = data => {
  return async dispatch => {
    try {
      let responseData = await get(`${APIServerIP}`, data)
      // console.log("volunteers get users", responseData)
      if (responseData.response_code === 200) {
        dispatch(setvolunteerList(responseData.data))
      }
    } catch (err) {
      console.log("try error volunteers", err)
    }
  }
}


// export const scanningData = data => {
//   return async dispatch => {
//     try {
//       let responseData = await post(`${APIServerIP}manage-booking-user/scan-ticket`, data)
//       console.log("responseData", responseData)
//       // if (responseData.response_code === 200) {
//       dispatch(ticketScanned(responseData))
//       // }
//     } catch (error) {
//       console.log("error", error)
//     }
//   }
// }
export const scanningData = data => {
  return async dispatch => {
    try {
      let responseData = await post(
        `${APIServerIP}manage-booking-user/scan-ticket`,
        data
      )

      console.log("SCAN RESPONSE 👉", responseData)

      dispatch(ticketScanned(responseData))

      // ✅ FIXED CONDITION
      if (
        responseData.status === "SUCCESS" ||
        responseData.status === "ALREADY_SCANNED"
      ) {
        dispatch(getScannedList(data.venue_id))
      }

    } catch (error) {
      console.log("error", error)
    }
  }
}
export const getScannedList = (venue_id) => {
  return async dispatch => {
    try {
      let responseData = await get(
        `${APIServerIP}manage-booking-user/scanned-list/${venue_id}`
      )

      console.log("API RESPONSE 👉", responseData)   // ✅ ADD THIS

      if (responseData.response_code === 200) {
        dispatch(setScannedList(responseData.data))
      }
    } catch (error) {
      console.log("error", error)
    }
  }
}

export const {
  setVenueList,
  setVenueSuccessfullyAdded,
  setUserEdit,
  setTicketBookedList,
  resetVenue,
  setvolunteerList,
  ticketScanned,setScannedList   ,
  resetScannedData
} = VenueSlice.actions

export default VenueSlice.reducer
